import type { BrandConfig } from "./types";

/**
 * Default brand — used when no subdomain matches.
 * In production this registry is replaced by an API call
 * (GET /v1/brands/resolve?host=...), cached per session.
 */
export const DEFAULT_BRAND: BrandConfig = {
  id: "default",
  name: "Setapi",
  tagline: "Algo Trading Platform",
  colors: { primary: "#1F6BFF", accent: "#0EA5BA" },
};

/** Demo registry — swap for API resolution before launch. */
const REGISTRY: Record<string, BrandConfig> = {
  acme: {
    id: "acme",
    name: "Acme Capital",
    tagline: "Algo Trading Platform",
    colors: { primary: "#7C5CF0", accent: "#0EA5BA" },
  },
  zenith: {
    id: "zenith",
    name: "Zenith Wealth",
    tagline: "Algo Trading Platform",
    colors: { primary: "#0EA5BA", accent: "#1F6BFF" },
  },
};

export function resolveBrand(hostname: string): BrandConfig {
  const sub = (hostname.split(".")[0] ?? "").toLowerCase();
  // ignore www / bare ips / localhost sub-parts
  if (!sub || sub === "www" || sub === "localhost") return DEFAULT_BRAND;
  return REGISTRY[sub] ?? DEFAULT_BRAND;
}
